import { vservice } from '@niknevis/vue-modules'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'

@vservice()
export class EditorService {
  imageUpload(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return HTTP.post(
      Ziggy.route('panel.editor_uploader').toString(),
      formData
    ).then(response => response.json())
  }
}
